import { AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import { PROGRAMS_URL } from "@/api/URL-constants";

import { PROGRAMME } from "@/constants/programmes.constants";

import {
  GetAllProgramsResponse,
  ProgramToCreate,
  ProgramToCreateResponse,
  ProgramToUpdate
} from "@/models/api/program.model";
import { Programme } from "@/models/programme.model";

const getAll = (): Promise<Programme[]> => {
  return DAO_SESHAT()
    .get(PROGRAMS_URL)
    .then((response: AxiosResponse<GetAllProgramsResponse>): Programme[] => {
      if (response.status === 200) {
        return response.data.data;
      } else if (response.status === 204) {
        return [];
      } else {
        throw new Error(PROGRAMME.ERRORS.loading + "s");
      }
    });
};

const create = (
  payload: ProgramToCreate
): Promise<AxiosResponse<ProgramToCreateResponse>> => {
  return DAO_SESHAT().post(PROGRAMS_URL, payload);
};

const update = (payload: ProgramToUpdate): Promise<AxiosResponse> => {
  return DAO_SESHAT().put(PROGRAMS_URL, payload);
};

const remove = (programId: number): Promise<AxiosResponse> => {
  return DAO_SESHAT().delete(`${PROGRAMS_URL}/${programId}`);
};

export { getAll, create, update, remove };
